import { axiosClient } from "@/api/axios";

export function sendMailToUser(payload) {
  return axiosClient.post("email/send/to-user", payload);
}

export function sendProblemReport(payload) {
  return axiosClient.post("email/send/problem-report", payload);
}
